import React, { memo, useState } from 'react';
import { Marker } from 'react-map-gl';

type TSearchMapClusterMarkerProps = {
  lat: number;
  lon: number;
  count: number;
  onClick?: () => void;
};

export const SearchMapClusterMarker = memo(function SearchMapClusterMarker({
  lat,
  lon,
  count,
  onClick,
}: TSearchMapClusterMarkerProps) {
  const [isInFocus, setIsInFocus] = useState(false);

  return (
    <Marker latitude={lat} longitude={lon} style={{ zIndex: isInFocus ? 5 : 0 }}>
      <button
        data-testid="map-cluster-pin"
        onClick={onClick}
        onMouseEnter={() => setIsInFocus(true)}
        onMouseLeave={() => setIsInFocus(false)}
        className="relative flex items-center justify-center w-10 h-10 overflow-hidden text-white bg-gray-800 rounded-tag">
        <span className="flex font-medium autoType300 text">{count}</span>
      </button>
    </Marker>
  );
});
